<template>

  <div class="Shortcut" :class="{ 'is--active' : active }">
    <component :is="type" :href="href" :to="to">
      <div class="inner">
        <Icon :name="icon" />
        <span v-if="count > 0" class="count">
          <span>{{ count }}</span>
          <svg width="7" height="8" viewBox="0 0 7.63 8.06">
            <path d="M2,0,0,8.06,7.63,5.63Z"/>
          </svg>
        </span>
      </div>
    </component>
    <slot></slot>
  </div>

</template>

<script>
  import { gsap } from 'gsap'
  import Icon from '@components/Icon'

  export default {
    components: {
      Icon
    },
    props: {
      active: {
        type: Boolean,
        default: false
      },
      href: {
        type: String,
        default: null
      },
      to: {
        type: String,
        default: null
      },
      count: {
        type: Number,
        default: 0
      },
      icon: {
        type: String,
        default: null
      }
    },
    computed: {
      type() {
        if (this.to) {
          return 'router-link'
        } else if(this.href) {
          return 'a'
        } else {
          return 'button'
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "~@sass/components/_Shortcut.scss";
</style>
